import { EVINCED_SEVERITIES_IDS } from '@evinced-private/ui-common';

export type SummaryPaneResult = {
	totalScans: number;
	totalIssues: number;
	averagePerScan: number;
	criticalIssues: number;
	addedToJira: number; // todo: rename to "addedToTicket"
	iosScans: number;
	androidScans: number;
	hasIosScans: boolean;
	hasAndroidScans: boolean;
};

type SeverityFilterField =
	| 'critical_issues_gt'
	| 'serious_issues_gt'
	| 'moderate_issues_gt'
	| 'minor_issues_gt'
	| 'best_practice_issues_gt'
	| 'needs_review_issues_gt';

export const SEVERITY_FILTER_MAP: Record<EVINCED_SEVERITIES_IDS, SeverityFilterField> = {
	[EVINCED_SEVERITIES_IDS.CRITICAL]: 'critical_issues_gt',
	[EVINCED_SEVERITIES_IDS.SERIOUS]: 'serious_issues_gt',
	[EVINCED_SEVERITIES_IDS.MODERATE]: 'moderate_issues_gt',
	[EVINCED_SEVERITIES_IDS.MINOR]: 'minor_issues_gt',
	[EVINCED_SEVERITIES_IDS.BEST_PRACTICE]: 'best_practice_issues_gt',
	[EVINCED_SEVERITIES_IDS.NEEDS_REVIEW]: 'needs_review_issues_gt'
};
